import BaseClient from '@/app/model/api/response/baseApiClient'

class GetImageApi extends BaseClient {
  public getImageData (bodyData: any) {
    const path = '/v1/field/image'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params
    if (bodyData.planting_id !== 0 && bodyData.planting_id !== undefined) {
      params = new URLSearchParams({ planting_id: bodyData.planting_id, date: bodyData.date })
    } else {
      params = new URLSearchParams({ crop_image_id: bodyData.crop_image_id })
    }

    if (bodyData.type !== '') {
      params.append('type', bodyData.type)
    }
    if (bodyData.crop_image_id !== undefined) {
      params.append('crop_image_id', bodyData.crop_image_id)
    }

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }

  public doResponseConvert (response: any) {
    if (response.status === 200) {
      return response.blob()
    } else {
      throw Error(response.status)
    }
  }

  public getPayload (data: any) {
    const outside: any = URL.createObjectURL(data)
    return outside
  }

  public doError (e: any) {
    // エラーの場合はデフォルト画像を返す
    return e
  }
}

export default new GetImageApi()
